import * as React from 'react';

import { LoadingContext } from 'contexts/LoadingContext';

export const useLoading = (): {
  loading: boolean;
  setLoading: ((args0: boolean) => void) | null;
} => {
  const { loading, setLoading } = React.useContext(LoadingContext);

  return {
    loading,
    setLoading,
  };
};
